namespace GeniuzPOS.Purchase {
    export interface ListAppInvoiceReceiveRow {
        SendForAppfg?: sendapp;
        WaitLv?: number;
        WaitApprove?: string;
        SysDocNo?: string;
        ItemTypeFg?: POTypeFg;
        SupplierId?: string;
        NetTotalInVat?: number;
        PurIvNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        LastApprove?: string;
        ApproveDate?: string;
        ShipId?: string;
        Remark?: string;
    }

    export namespace ListAppInvoiceReceiveRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'WaitApprove';
        export const localTextPrefix = 'Purchase.ListAppInvoiceReceive';
        export const lookupKey = 'Purchase.ListAppInvoiceReceive';

        export function getLookup(): Q.Lookup<ListAppInvoiceReceiveRow> {
            return Q.getLookup<ListAppInvoiceReceiveRow>('Purchase.ListAppInvoiceReceive');
        }
        export const deletePermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบแจ้งหนี้(IR):อนุมัติ:Modify';

        export declare const enum Fields {
            SendForAppfg = "SendForAppfg",
            WaitLv = "WaitLv",
            WaitApprove = "WaitApprove",
            SysDocNo = "SysDocNo",
            ItemTypeFg = "ItemTypeFg",
            SupplierId = "SupplierId",
            NetTotalInVat = "NetTotalInVat",
            PurIvNo = "PurIvNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            LastApprove = "LastApprove",
            ApproveDate = "ApproveDate",
            ShipId = "ShipId",
            Remark = "Remark"
        }
    }
}
